module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"graph":{"time":{"am":"am","pm":"pm"},"details":{"graph_type":"Agent Metrics","graph_title":"Average Handle Time","graph_description":"Average time spent handling an interaction","graph_legend":{"your_performance":"Your Performance","average_performance":"Agent Average"}},"actions":{"dismiss":"Dismiss"}}},"es":{"main":{}}}')
  delete Component.options._Ctor
}
